module.exports = __webpack_public_path__ + "static/img/铁路.7adac526.png";